module.exports = "https://p.cds.unp.clasificados.pe/logo-depor-grey.99a61e158f29caea4eb24993554eabf8.svg";